module.exports = __webpack_public_path__ + "8918e093f5e0fbf37edf9ded3bd52263.svg";